export const SET_DATA = "@IMPORTS_TRACER/SET_DATA";
export const READ = "@IMPORTS_TRACER/READ";
export const READ_FAIL = "@IMPORTS_TRACER/READ_FAIL";
export const READ_SUCCESS = "@IMPORTS_TRACER/READ_SUCCESS";
export const REQUEST_READ = "@IMPORTS_TRACER/REQUEST_READ";

